
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as preview5d59c0NdFJyN9ePPjQ0xh_Ke3_LpJ015GPjpKMAj53sMeta } from "/app/pages/preview.vue?macro=true";
import { default as _91_91slug_93_93on4DX_ln261ccS7cVlVj42nyDkayPKDaZP_455VWqejPkMeta } from "/app/pages/[[slug]].vue?macro=true";
import { default as indexlHdSPZsigQHgQJsOVXW951uO9VnEBrdDrvcPFY3Wx3QMeta } from "/app/pages/local/index.vue?macro=true";
import { default as indexOBlK6oUwkkSN7Nb2wyktNIetcmk30PXHlR1YM3sYeYEMeta } from "/app/pages/es/zona/index.vue?macro=true";
import { default as _91postcode_93lzuTYQ75tuHGbn9nJHz_45wiruVzie1xQKIL_vyCxDXXcMeta } from "/app/pages/local/[postcode].vue?macro=true";
import { default as _91postcode_93I43t_457RleucLDhj6pVUcMW56q1E9Q1mBXI7IbMz0Q1oMeta } from "/app/pages/es/zona/[postcode].vue?macro=true";
import { default as _91_91slug_93_93joS06NvP4Aeln10Cdlx2umYm6eYZKxRYj9gGQnZQWeMMeta } from "/app/pages/[[level_1]]/[[slug]].vue?macro=true";
import { default as _91_91slug_93_93dDEWOmw6D1Pie6UHCkW6Rwx4vKfZrDhIjaOl03OLgbsMeta } from "/app/pages/[[level_1]]/[[level_2]]/[[slug]].vue?macro=true";
import { default as _91_91slug_93_93L2HVayU_4HWTa46BDSRoyyKOHpjx_oKXZA1J_45CrI4RoMeta } from "/app/pages/[[level_1]]/[[level_2]]/[[level_3]]/[[slug]].vue?macro=true";
export default [
  {
    name: "preview___en",
    path: "/preview",
    component: () => import("/app/pages/preview.vue")
  },
  {
    name: "preview___us",
    path: "/us/preview",
    component: () => import("/app/pages/preview.vue")
  },
  {
    name: "preview___es",
    path: "/es/preview",
    component: () => import("/app/pages/preview.vue")
  },
  {
    name: "slug___en",
    path: "/:slug?",
    component: () => import("/app/pages/[[slug]].vue")
  },
  {
    name: "slug___us",
    path: "/us/:slug?",
    component: () => import("/app/pages/[[slug]].vue")
  },
  {
    name: "slug___es",
    path: "/es/:slug?",
    component: () => import("/app/pages/[[slug]].vue")
  },
  {
    name: "local___en",
    path: "/local",
    meta: indexlHdSPZsigQHgQJsOVXW951uO9VnEBrdDrvcPFY3Wx3QMeta || {},
    component: () => import("/app/pages/local/index.vue")
  },
  {
    name: "local___us",
    path: "/us/local",
    meta: indexlHdSPZsigQHgQJsOVXW951uO9VnEBrdDrvcPFY3Wx3QMeta || {},
    component: () => import("/app/pages/local/index.vue")
  },
  {
    name: "local___es",
    path: "/es/local",
    meta: indexlHdSPZsigQHgQJsOVXW951uO9VnEBrdDrvcPFY3Wx3QMeta || {},
    component: () => import("/app/pages/local/index.vue")
  },
  {
    name: "es-zona___en",
    path: "/es/zona",
    meta: indexOBlK6oUwkkSN7Nb2wyktNIetcmk30PXHlR1YM3sYeYEMeta || {},
    component: () => import("/app/pages/es/zona/index.vue")
  },
  {
    name: "es-zona___us",
    path: "/us/es/zona",
    meta: indexOBlK6oUwkkSN7Nb2wyktNIetcmk30PXHlR1YM3sYeYEMeta || {},
    component: () => import("/app/pages/es/zona/index.vue")
  },
  {
    name: "es-zona___es",
    path: "/es/es/zona",
    meta: indexOBlK6oUwkkSN7Nb2wyktNIetcmk30PXHlR1YM3sYeYEMeta || {},
    component: () => import("/app/pages/es/zona/index.vue")
  },
  {
    name: "local-postcode___en",
    path: "/local/:postcode()",
    meta: _91postcode_93lzuTYQ75tuHGbn9nJHz_45wiruVzie1xQKIL_vyCxDXXcMeta || {},
    component: () => import("/app/pages/local/[postcode].vue")
  },
  {
    name: "local-postcode___us",
    path: "/us/local/:postcode()",
    meta: _91postcode_93lzuTYQ75tuHGbn9nJHz_45wiruVzie1xQKIL_vyCxDXXcMeta || {},
    component: () => import("/app/pages/local/[postcode].vue")
  },
  {
    name: "local-postcode___es",
    path: "/es/local/:postcode()",
    meta: _91postcode_93lzuTYQ75tuHGbn9nJHz_45wiruVzie1xQKIL_vyCxDXXcMeta || {},
    component: () => import("/app/pages/local/[postcode].vue")
  },
  {
    name: "es-zona-postcode___en",
    path: "/es/zona/:postcode()",
    meta: _91postcode_93I43t_457RleucLDhj6pVUcMW56q1E9Q1mBXI7IbMz0Q1oMeta || {},
    component: () => import("/app/pages/es/zona/[postcode].vue")
  },
  {
    name: "es-zona-postcode___us",
    path: "/us/es/zona/:postcode()",
    meta: _91postcode_93I43t_457RleucLDhj6pVUcMW56q1E9Q1mBXI7IbMz0Q1oMeta || {},
    component: () => import("/app/pages/es/zona/[postcode].vue")
  },
  {
    name: "es-zona-postcode___es",
    path: "/es/es/zona/:postcode()",
    meta: _91postcode_93I43t_457RleucLDhj6pVUcMW56q1E9Q1mBXI7IbMz0Q1oMeta || {},
    component: () => import("/app/pages/es/zona/[postcode].vue")
  },
  {
    name: "level_1-slug___en",
    path: "/:level_1?/:slug?",
    component: () => import("/app/pages/[[level_1]]/[[slug]].vue")
  },
  {
    name: "level_1-slug___us",
    path: "/us/:level_1?/:slug?",
    component: () => import("/app/pages/[[level_1]]/[[slug]].vue")
  },
  {
    name: "level_1-slug___es",
    path: "/es/:level_1?/:slug?",
    component: () => import("/app/pages/[[level_1]]/[[slug]].vue")
  },
  {
    name: "level_1-level_2-slug___en",
    path: "/:level_1?/:level_2?/:slug?",
    component: () => import("/app/pages/[[level_1]]/[[level_2]]/[[slug]].vue")
  },
  {
    name: "level_1-level_2-slug___us",
    path: "/us/:level_1?/:level_2?/:slug?",
    component: () => import("/app/pages/[[level_1]]/[[level_2]]/[[slug]].vue")
  },
  {
    name: "level_1-level_2-slug___es",
    path: "/es/:level_1?/:level_2?/:slug?",
    component: () => import("/app/pages/[[level_1]]/[[level_2]]/[[slug]].vue")
  },
  {
    name: "level_1-level_2-level_3-slug___en",
    path: "/:level_1?/:level_2?/:level_3?/:slug?",
    component: () => import("/app/pages/[[level_1]]/[[level_2]]/[[level_3]]/[[slug]].vue")
  },
  {
    name: "level_1-level_2-level_3-slug___us",
    path: "/us/:level_1?/:level_2?/:level_3?/:slug?",
    component: () => import("/app/pages/[[level_1]]/[[level_2]]/[[level_3]]/[[slug]].vue")
  },
  {
    name: "level_1-level_2-level_3-slug___es",
    path: "/es/:level_1?/:level_2?/:level_3?/:slug?",
    component: () => import("/app/pages/[[level_1]]/[[level_2]]/[[level_3]]/[[slug]].vue")
  }
]